export default __webpack_public_path__ + "static/media/5VMWare.d2b9f534.svg";